/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated';
import { createAddScalar } from '../../factoriesAny.js';
export var addScalarDependencies = {
  typedDependencies: typedDependencies,
  createAddScalar: createAddScalar
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesAddScalar.generated.js
// module id = 44
// module chunks = 0